import PropTypes from "prop-types";
import React from "react";
import { Button } from "reactstrap";
import "./SimpleButton.scss";
import cn from "classname";
import { isNovium, isB2C } from "../../libs/env";

const SimpleButton = ({ label, ...props }) => {
  let svg_fill = "black";
  if((isB2C.some(domain => window.location.origin.includes(domain)) || window.location.origin.includes(isNovium)))
  {
    svg_fill = "white"
  }
  return (
    <Button className={cn("simple-button")} {...props}>
        {label === "Open" ?(
            <b>{label}</b>
        ):(
          <>
            <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3847 1.75977C14.0675 1.75977 17.0585 4.86346 17.1041 8.71019C17.15 12.5715 14.1839 15.775 10.4984 15.8388C7.41081 15.8923 4.78941 13.7637 3.94791 10.8282C3.75877 10.1687 4.22986 9.50436 4.88718 9.50436L10.2158 9.50375C10.5652 9.50375 10.7403 9.94645 10.4932 10.2052L9.42958 11.319C9.19344 11.5665 9.16977 11.9522 9.35879 12.2273L9.42958 12.3146C9.66583 12.562 10.0341 12.5868 10.2966 12.3889L10.38 12.3146L13.26 9.29749C13.4962 9.04999 13.5198 8.66427 13.3309 8.38914L13.26 8.30186L10.395 5.30043C10.1319 5.02482 9.70004 5.00689 9.43436 5.2798C9.19377 5.52706 9.16857 5.91611 9.35877 6.19309L9.42955 6.28037L10.4923 7.39326C10.7394 7.65205 10.5644 8.09462 10.2151 8.09474L4.88737 8.09487C4.22914 8.09487 3.75898 7.42934 3.94846 6.76896C4.75927 3.94469 7.21756 1.86767 10.1537 1.76364L10.3847 1.75977Z" fill="white"/>
            </svg> 
            <b>
              {label}
            </b>
          </>
        )}
    </Button>
  );
};

SimpleButton.propTypes = {
  label: PropTypes.string.isRequired,
};

export default SimpleButton;
